'use strict';Object.defineProperty(exports,"__esModule",{value:true});exports.default=isNodeSupported;var _nodeType=require('./node-type');var _nodeType2=_interopRequireDefault(_nodeType);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function isNodeSupported(){var node=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return!(isNodeTypeIgnored(node.nodeType)||isNodeValueIgnored(node.nodeValue));}/**
 * Node types that are not supported.
 * @type {Array}
 */var IGNORED_NODE_TYPES=[_nodeType2.default.COMMENT];/**
 * Checks if provided node type is ignored (not supported).
 * @param {Number} nodeType
 * @return {Boolean}
 */var isNodeTypeIgnored=function isNodeTypeIgnored(nodeType){return IGNORED_NODE_TYPES.indexOf(nodeType)>-1;};/**
 * Checks if provided node value is ignored (not supported).
 * @param {String} nodeValue
 * @return {Boolean}
 */var isNodeValueIgnored=function isNodeValueIgnored(nodeValue){return nodeValue!==null&&nodeValue.trim()==='';};